import { makeStyles } from '@freighthub/silhouette-core'
import { FC, useContext } from 'react'

import { TpTimestampRangeCtx, TTpTimestampRangeCtx } from '../service/TpTimestampRangeContext'
import { DelayViewData } from './TpDelay'
import { DelayInfoIcon } from './TpDelayInfoIcon'
import { Reason } from './TpReason'

export const testIds = {
  twoDelayString: 'two_delay_string',
}

const useStyles = makeStyles({
  wrapper: {
    whiteSpace: 'nowrap',
  },
})

interface TwoDelaysStringAndReasonCtx {
  showTooltip: boolean
}

interface TwoDelaysStringAndReasonProps {
  smallestDelayData: DelayViewData
  biggestDelayData: DelayViewData
  tooltip: string
  reason: string
}

interface LeanTwoDelaysStringAndReasonProps
  extends TwoDelaysStringAndReasonProps,
    Partial<TwoDelaysStringAndReasonCtx> {}

// (+5d - +10d) reason
export const LeanTwoDelaysStringAndReason: FC<LeanTwoDelaysStringAndReasonProps> = ({
  biggestDelayData,
  showTooltip = true,
  reason,
  smallestDelayData,
  tooltip,
}) => {
  const classes = useStyles()
  return (
    <>
      <span className={classes.wrapper} data-testid={testIds.twoDelayString}>
        <span> (</span>
        <span className={smallestDelayData.colorClass}>{smallestDelayData.delayString}</span>
        <span> - </span>
        <span className={biggestDelayData.colorClass}>{biggestDelayData.delayString}</span>
        <span>)</span>
        {showTooltip && <DelayInfoIcon tooltip={tooltip} />}
      </span>
      {/* @ts-expect-error TS(2322) FIXME: Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message */}
      <Reason colorClass={biggestDelayData.colorClass} reason={reason} />
    </>
  )
}

export const TwoDelaysStringAndReason: FC<TwoDelaysStringAndReasonProps> = (props) => {
  const { showTooltip }: TTpTimestampRangeCtx = useContext(TpTimestampRangeCtx)
  return <LeanTwoDelaysStringAndReason showTooltip={showTooltip} {...props} />
}
